import * as React from 'react';

import {useQuery, useMutation} from '@apollo/react-hooks';

import {EmailSequenceProgression} from 'shells/sequence-progression/email-sequence-progression';

import type {
    CancelDripSequenceForEntity as CancelDripSequenceForEntityMutation,
    CancelDripSequenceForEntityVariables as CancelDripSequenceForEntityMutationVariables,
    GetContactDripSequenceProgressions as GetContactDripSequenceProgressionsQuery,
    GetContactDripSequenceProgressionsVariables as GetContactDripSequenceProgressionsQueryVariables,
} from 'nutshell-graphql-types';

import CANCEL_DRIP_PROGRESSION from '../../../email-marketing/drip-sequences/recipient-modal/graphql/mutations/cancel-drip-sequence-for-entity.graphql';
import {MessageBodyPreviewModal} from '../../../email-marketing/drip-sequences/recipient-modal/message-body-preview-modal';

import GET_CONTACT_DRIP_SEQUENCE_PROGRESSIONS from './graphql/queries/get-contact-drip-sequence-progressions.graphql';

type Props = {
    contactId: string;
};

export function PersonDripSequenceProgressionSection(props: Props) {
    const [editionToShow, setEditionToShow] = React.useState<string | null | undefined>(undefined);

    const [cancelDripProgression] = useMutation<
        CancelDripSequenceForEntityMutation,
        CancelDripSequenceForEntityMutationVariables
    >(CANCEL_DRIP_PROGRESSION);

    const {data, refetch} = useQuery<
        GetContactDripSequenceProgressionsQuery,
        GetContactDripSequenceProgressionsQueryVariables
    >(GET_CONTACT_DRIP_SEQUENCE_PROGRESSIONS, {
        variables: {contactId: props.contactId},
        notifyOnNetworkStatusChange: true,
    });

    const contact = {
        id: data && data.contact ? data.contact.id : '',
        name: data && data.contact ? data.contact.name : '',
        htmlUrl: data && data.contact ? data.contact.htmlUrl : '',
    } as const;

    // @ts-expect-error
    const emailSequences = [];
    if (data && data.contact) {
        data.contact.dripProgressions.forEach((sequence) => {
            if (sequence.nextEdition && sequence.nextEditionSendTime && sequence.campaign) {
                emailSequences.push({
                    id: sequence.id,
                    name: sequence.campaign.name,
                    htmlUrlPath: sequence.campaign.htmlUrlPath,
                    length: sequence.campaign.editions.totalCount,
                    totalSent: sequence.numEditionsSent,
                    sendTime: sequence.nextEditionSendTime,
                    nextEdition: sequence.nextEdition
                        ? {
                              ...sequence.nextEdition,
                              emailTemplate: sequence.nextEdition.emailTemplate
                                  ? {
                                        id: sequence.nextEdition.emailTemplate.id,
                                    }
                                  : null,
                          }
                        : null,
                    entity: contact,
                    isPaused: Boolean(sequence.campaign.status === 'PAUSED'),
                });
            }
        });
    }

    return emailSequences.length ? (
        <>
            <div className='mb-16'>
                <EmailSequenceProgression
                    label='Drip sequences'
                    isDripSequence={true}
                    // @ts-expect-error
                    emailSequences={emailSequences}
                    entityType='person'
                    showPreviewModal={(emailTemplateId) => {
                        setEditionToShow(emailTemplateId);
                    }}
                    onCancelSequenceProgression={(dripProgressionId: string) =>
                        cancelDripProgression({
                            variables: {
                                dripProgressionDeleteInput: {
                                    dripProgressionId,
                                },
                            },
                        }).then(() => refetch())
                    }
                />
            </div>
            {editionToShow ? (
                <MessageBodyPreviewModal
                    onClose={() => {
                        setEditionToShow(undefined);
                    }}
                    emailTemplateId={editionToShow}
                    entityId={props.contactId}
                />
            ) : undefined}
        </>
    ) : null;
}
